@if(show)
{
<div class="notification-container">
  <span class="notification-text">NOTE THIS IS A TEST SYSTEM! Please only use for testing purposes.</span>
  <div class="notification-button">
    <a class="notification-link" (click)="close($event)">Got it!</a>
  </div>
</div>
}
